// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"dd5826a9","238":"43d8b2d6","239":"e39fb35b","355":"1fd05948","455":"73344983","578":"eece98a5","788":"8912938a","857":"44f4b707","977":"23814c44"}[chunkId] + ".chunk.js";
};